import { Subscription } from 'rxjs';
import {Component, ViewChild, ViewContainerRef, Injector, OnDestroy} from '@angular/core';
import {GridOptions} from 'ag-grid';
import {UsersService} from './users.service';
import {T2CardComponent} from '../../trip2-theme/components/t2-card/t2-card.component';
import { BooleanCheckComponent } from '../A2-utils/grid-components/boolean-check/boolean-check.component';
import any = jasmine.any;
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { ParentModule } from '../A2-utils/ParentClass/parent-module';
@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent extends ParentModule implements OnDestroy {
  private statusCreate= 'Add';
  private searchUserValue: string;
  private searchUser: string;
  private valueDob: string;
  private selectedUsers: any[];
  private showLoading= false;
  private Subscriptions: Subscription[] = [];

  public userSelected = null;
  protected userEditSelected= 0;
  protected activeAdd= false;
  protected enabledBtn= false;
  protected disabledBtnCloseSessions = true;
  protected gridUsers: GridOptions;
  protected showInactive= false;
  public    clicUser = null;
  public    usersModelPass: any;
  public    tab = 1;
  hideHistory = false;
  @ViewChild('closeSessionsModal')modal: T2CardComponent;


  constructor(protected service: UsersService,
    private sweetAlertHelper: SweetAlertHelper,
    protected inject: Injector
    ) {
    super('app-users', inject);
    this.gridUsers  =  <GridOptions>{};
    this.gridUsers.rowSelection = 'multiple';
    this.gridUsers.enableColResize = true;
    const self = this.gridUsers;
    const that = this;
    this.gridUsers.columnDefs = this.columnsDefinitions();
    this.gridUsers.onGridReady = function() {
      self.api.sizeColumnsToFit();
      that.autoSizeAll();
      that.callService();
    };
  }

  /**
   * @Description:
   * @returns {({colId: string; width: number; checkboxSelection: boolean; headerCheckboxSelection: boolean} | {headerName: string;
   * field: string; colId: string} | {headerName: string; field: string; colId: string; width: number})[]}
   */
  private columnsDefinitions() {
    return [
      {
        colId: 'id',
        width: 55,
        checkboxSelection: true,
        headerCheckboxSelection: true,
      },
      {
        headerName: 'Full Name',
        field: 'fullname',
        colId: 'fullname',
        cellRenderer: function (params) {
          let img = '';
          if (params.data.userphoto) {
            const valid = params.data.userphoto.split('http');
            if (valid.length >= 2) {
              img =  `
                      <span class="tooltip-img padding-r-5">
                        <img class="border-radius border-radius-50" src="${params.data.userphoto}" width="20" />
                      </span>
                      `;
            }
          }

          return `${img} ${params.data.fullname}`;
        }
      },
      {
        headerName: 'UserName',
        field: 'emailaddress',
        colId: 'description',

      },
      {
        headerName: 'Role',
        field: 'role.description',
        colId: 'role.roleid',

      },
      {
        headerName: 'Is Login',
        field: 'islogin',
        colId: 'islogin',
        width: 80,
        cellRendererFramework: BooleanCheckComponent
      },
      {
        headerName: 'Sessions',
        field: 'sessionsopen',
        colId: 'sessionsopen',
        width: 80,
        hide: true,
        suppressFilter: true,
        suppressMenu: true,
        suppressToolPanel: true
      },
       {
        headerName: 'Manager',
        field: 'ismanager',
        width: 80,
        cellRendererFramework: BooleanCheckComponent
      },
      {
        headerName: 'Active',
        field: 'isactive',
        colId: 'isactive',
        width: 80,
        cellRendererFramework: BooleanCheckComponent
      }

    ];
  }

  /**
   * @name autoSizeAll
   * @description Ajustar ancho de las columnas al su contenido
   */
  autoSizeAll() {
    const allColumnIds = [];
    this.gridUsers.columnApi.getAllColumns().forEach(function(column) {
      if (column['colId'] !== 'id') {
        allColumnIds.push(column['colId']);
      }
    });
    this.gridUsers.columnApi.autoSizeColumns(allColumnIds);
  }

  /**
   * @Description:
   * @returns {any[]}
   */
  private getSelectedUsers() {
    const users = [];
    this.gridUsers.api.getSelectedNodes().forEach(function(data){
      users.push(data.data.userprofileid);
    });
    return users;
  }

  /**
   * @Description:
   */
  callService() {
    this.Subscriptions.push(
      this.service.getUsersList('', this.showInactive)
        .subscribe({
          next: (data) => {
            if (data && data.length) {
              this.loadData(data);
              this.service.sendInfoManagers(data);
            } else {
              this.loadData([]);
            }
          },
          error: (err) => {
            this.sweetAlertHelper.captureException(err);
          }
        }
        )
    );
  }

  /**
   * @Description:
   * @param data
   */
  loadData(data) {
    if (this.gridUsers) {
      if (this.gridUsers.api) {
        const currentFilterModel = this.gridUsers.api.getFilterModel();
        this.gridUsers.api.setRowData(data);
        this.gridUsers.api.setFilterModel(currentFilterModel);
        // TODO Ajuste de tamaño de las columnas
        this.gridUsers.api.sizeColumnsToFit();
      }
    }
  }

  /**
   * @Description:
   * @param event
   */
  private filter(event) {
    this.gridUsers.api.setQuickFilter(event.target.value);
  }

  /**
   * @Description:
   * @param event
   */
  onPress(event) {
    this.service.getData(0, event).then((data) => {
      this.loadData(data);
    });
  }

  /**
   * @Description:
   */
  addNewUser() {
    this.clicUser = null;
    this.activeAdd = true;
    this.hideHistory = true;
    // this.loadForm();
  }

  /**
   * @Description:
   * @param event
   */
  editUser(event) {
    this.clicUser = event.data.userprofileid;
    this.usersModelPass = event.data;
    this.userSelected = event.data.userprofileid;
     this.activeAdd = true;
    // this.loadForm();
    this.enabledBtn = true;
    this.hideHistory = false;
  }

  loadForm() {
    this.activeAdd = false;
    setTimeout(() => {
    this.activeAdd = true;
    }, 200);
  }



  public openSessionModal() {
    this.selectedUsers = this.getSelectedUsers();
    if (this.selectedUsers.length !== 0) {
      this.modal.open();
    } else {
      this.sweetAlertHelper.createCustomAlert({text: 'Please check a user', type: 'warning'});
    }
  }


  public closeSessions() {
    this.showLoading = true;
    this.modal.viewProgressBar(true);
    this.service
      .closeAllSessions(this.selectedUsers)
      .finally(() => {
        this.modal.viewProgressBar(false);
      })
      .subscribe(
        data => {
          this.sweetAlertHelper.createCustomAlert({title: data.message, type: 'success'});
          this.callService();
          this.userSelected = 0;
          this.modal.close();
          this.showLoading = false;
        },
        error => {
          this.sweetAlertHelper.createCustomAlert({title: error, type: 'error'});
        }
      );
  }

  /**
   * @Description:
   */
  changeActiveAdd() {
    this.clicUser = null;
    this.activeAdd = false;
    this.onSelectionChanged();
  }

  onSelectionChanged(event?) {

    this.disabledBtnCloseSessions = !event.api.getSelectedNodes().length;
  }

  /**
   * @Description:
   * @param {number} usrsId
   */
  onUserSelected(usrsId: number) {
    this.userSelected = usrsId;
  }

  /**
   * @Description:
   * @param {string} dobValue
   */
  onDob(dobValue: string) {
    this.valueDob = dobValue;
  }

  /**
   * @Description:
   * @param {string} searchValue
   */
  onSearchUser(searchValue: string ) {
    this.searchUserValue = searchValue;
  }

  /**
   * @Description
   * @param resp
   */
  onNotify(resp): void {
    this.sweetAlertHelper.createCustomAlert({title: resp.message, type: 'info'});
    this.callService();
    // // this.gridUsers.api.refreshView();
    if (this.activeAdd) {
      this.changeActiveAdd();
    }
  }

  /**
   * @Description:
   */
  showDisable() {
    this.callService();
  }

  get rowCountGridUsers(): number {
    if (this.gridUsers && this.gridUsers.api) {
      return this.gridUsers.api.getDisplayedRowCount();
    }
    return 0;
  }

  ngOnDestroy(): void {
    this.Subscriptions.forEach(s => s.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/users/users.component.ts